import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { checkDoShowAgentCommission } from '../../../store/slices/user';
import currencySymbol from '../../../helpers/currencySymbol';
import getCommissionLabel from '../../../helpers/getCommissionLabel';

const AgentCommission = ({
  agentCommission, className, commissionPercentage, currencyCode, mode,
}) => {
  const doShowAgentCommission = useSelector(checkDoShowAgentCommission);
  const { travelAgency } = useSelector((store) => store.user);

  if (!doShowAgentCommission) {
    return <></>;
  }
  return (
    <div className={`p-2 rounded-lg bg-orange-200 text-black flex justify-between ${className}`}>
      <div>
        {getCommissionLabel(travelAgency, mode)}
        {commissionPercentage > 0 ? (
          <>
            {' '}
            (
            <NumberFormat value={commissionPercentage} displayType="text" decimalScale="0" />
            %):
          </>
        ) : ':'}
      </div>
      <div className="text-right ml-1">
        <NumberFormat
          value={agentCommission === null
            ? 0
            : agentCommission}
          prefix={currencySymbol(currencyCode)}
          displayType="text"
          thousandSeparator
          fixedDecimalScale="true"
          decimalScale="2"
        />
      </div>
    </div>
  );
};

AgentCommission.propTypes = {
  agentCommission: PropTypes.number,
  className: PropTypes.string,
  commissionPercentage: PropTypes.number,
  currencyCode: PropTypes.string,
  mode: PropTypes.number,
};

AgentCommission.defaultProps = {
  className: '',
  agentCommission: null,
  commissionPercentage: null,
  currencyCode: 'USD',
  mode: null,
};

export default AgentCommission;
